<template>
  <div class="flex h-auto bg-gray-900 text-white">
    <!-- Sidebar -->
    <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg">
      <div class="flex items-center justify-center space-x-3">
        <img src="@/assets/logo.svg" alt="Syniac Logo" class="h-20">
      </div>
      <Navbar></Navbar>
    </aside>

    <!-- Main Content -->
    <div class="flex-1 flex flex-col">
      <!-- Top Navbar -->
      <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md">
        <h2 class="text-xl font-semibold">Orders</h2>
      </header>

      <!-- Orders Page -->
      <main class="p-6 flex-1">
        <div class="bg-gray-800 p-6 rounded-xl shadow-md flex flex-col h-full">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold">Order Overview</h3>

            <!-- Search Input -->
            <input
              v-model="searchQuery"
              type="text"
              placeholder="Search orders..."
              class="px-3 py-2 rounded-md bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring focus:ring-blue-500"
            />
          </div>

          <div class="overflow-x-auto">
            <table class="w-full text-left border-collapse">
              <thead>
                <tr class="bg-gray-700">
                  <th class="p-3">Order ID</th>
                  <th class="p-3">Customer</th>
                  <th class="p-3">Amount</th>
                  <th class="p-3">Plan</th>
                  <th class="p-3">Date</th>
                  <th class="p-3">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="order in filteredOrders"
                  :key="order.id"
                  class="border-b border-gray-600"
                >
                  <td class="p-3">#{{ order.id }}</td>
                  <td class="p-3">#{{ order.user_id }}</td>
                  <td class="p-3">${{ order.amount }}</td>
                  <td class="p-3">{{ order.plan }}</td>
                  <td class="p-3">{{ formatDate(order.created_at) }}</td>
                  <td class="p-3">
                    <button
                      class="px-3 py-1 bg-blue-500 rounded hover:bg-blue-600"
                      @click="viewOrder(order.id)"
                    >
                      View
                    </button>
                  </td>
                </tr>

                <!-- No results row -->
                <tr v-if="filteredOrders.length === 0">
                  <td colspan="6" class="p-3 text-center text-gray-400">
                    No orders found.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/adminnav.vue';
import axios from 'axios';

export default {
  name: "OrdersPage",
  components: { Navbar },
  data() {
    return {
      orders: [],
      searchQuery: ""
    };
  },
  computed: {
    filteredOrders() {
      if (!this.searchQuery) return this.orders;
      const query = this.searchQuery.toLowerCase();
      return this.orders.filter(order =>
        String(order.id).includes(query) ||
        String(order.user_id).includes(query) ||
        (order.plan && order.plan.toLowerCase().includes(query)) ||
        (String(order.amount).includes(query)) ||
        (order.created_at && new Date(order.created_at).toLocaleDateString("en-US").toLowerCase().includes(query))
      );
    }
  },
  methods: {
    async fetchOrders() {
      try {
        const response = await axios.get('https://api.syniac.com:3000/api/admin/order/orders', { withCredentials: true });
        this.orders = response.data;
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    },
    viewOrder(orderId) {
      this.$router.push(`/orders/${orderId}`);
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("en-US");
    }
  },
  mounted() {
    this.fetchOrders();
  }
};
</script>

<style scoped>
tbody tr:hover {
  background-color: rgba(59, 130, 246, 0.2);
}
</style>
